import React, {useEffect, useState} from "react";
import Spinner from "../../../spinner";
import {Button, Col, DatePicker, Table, Row, notification, Icon} from "antd";
import {reportService} from "../../../../services/report.services";
import moment from "moment";
import i18n from "../../../../i18n";
import { useConsignorFilter } from '../../../../hooks/use-consignor-filter';
import ConsignorFilterSelect from '../../../consignor-filter-select';

export default function ReportStatsRefusedDeliveries() {
  const consignorFilter = useConsignorFilter();
  const { isOwnerUser, selectedConsignor, setSelectedConsignor } = consignorFilter;

  const [loading, setLoading] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const [isNeedUpdateReport, setIsNeedUpdateReport] = useState(false);
  // параметры для построения отчета
  const [dateStart, setDateStart] = useState(moment().startOf("month"));
  const [dateEnd, setDateEnd] = useState(moment().endOf("month"));
  // полученные данные отчета
  const [reportData, setReportData] = useState([]);
  const [reportDataParsed, setReportDataParsed] = useState([]);

  const colW = (isOwnerUser ? 4 : 5);

  // при первом открытии автоматически запрашиваем данные
  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      setIsNeedUpdateReport(true);
    }

    if (isNeedUpdateReport) {
      // запрос на получение данных отчета
      reportService
        .getStatsRefusedDeliveries(
          dateStart.format("YYYY-MM-D"),
          dateEnd.format("YYYY-MM-D"),
          null,
          isOwnerUser ? selectedConsignor : null
        )
        .then((response) => {
          setReportData([]);
          let tableData = [];
          response[0]['data'].map((item) => {
            tableData.push(item);
            return null;
          });

          let reindexedTableData = [];
          for (let key in tableData) {
            reindexedTableData.push(tableData[key]);
          }

          setIsNeedUpdateReport(false);
          setLoading(false);
          setReportData(reindexedTableData);

          setIsNeedUpdateReport(false);
          setLoading(false);
        })
        .catch((errorMsg) => {
          setIsNeedUpdateReport(false);
          setLoading(false);
          notification.error({
            message: i18n.t('components.notification.titles.getStatsRefusedDeliveries'),
            description: errorMsg,
          });
        });
    }
  }, [isNeedUpdateReport]);

  const columns = [
    {
      title: i18n.t('reportsPage.statsRefusedDeliveries.table.from.title'),
      dataIndex: "from",
      key: "from",
      width: "30%",
    },
    {
      title: i18n.t('reportsPage.statsRefusedDeliveries.table.to.title'),
      dataIndex: "to",
      key: "to",
      width: "20%",
    },
    {
      title: i18n.t('reportsPage.statsRefusedDeliveries.table.reason.title'),
      dataIndex: "reason",
      key: "reason",
      width: "15%",
    },
    {
      title: i18n.t('reportsPage.statsRefusedDeliveries.table.delivDateCreated.title'),
      dataIndex: "delivDateCreated",
      key: "delivDateCreated",
      width: "10%",
      sorter: (a, b) => {
        return (
          moment(a.delivDateCreatedObj).unix() -
          moment(b.delivDateCreatedObj).unix()
        );
      },
    },
    {
      title: i18n.t('reportsPage.statsRefusedDeliveries.table.dateRefuse.title'),
      dataIndex: "dateRefuse",
      key: "dateRefuse",
      width: "15%",
      sorter: (a, b) => {
        return moment(a.dateRefuseObj).unix() - moment(b.dateRefuseObj).unix();
      },
    },
    {
      title: i18n.t('reportsPage.statsRefusedDeliveries.table.whoCancel.title'),
      dataIndex: "whoCancel",
      key: "whoCancel",
      width: "15%",
    },
  ];

  return (
    <React.Fragment>
      <div className="reports__header">
        <h1 className="content-header">
          {i18n.t('reportsPage.statsRefusedDeliveries.title')}
        </h1>
        <Icon type='filter'
              theme={isFilterOpen ? '' : "filled"}
              onClick={() => {
                setIsFilterOpen(!isFilterOpen)
              }}
              className="reports__filter-toggle"/>
        {isFilterOpen && <div className={`reports__filter ${isFilterOpen ? 'is-open' : ""}`}>
          <Row gutter={12} style={{padding: "0", rowGap: "10px"}} type="flex" justify="start">
            <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <DatePicker
                style={{width: "100%"}}
                defaultValue={dateStart}
                format="DD.MM.YYYY"
                size="normal"
                name="dateStart"
                placeholder={i18n.t('reportsPage.statsRefusedDeliveries.filter.dateStart.placeholder')}
                allowClear={false}
                onChange={(date) => {
                  setDateStart(date);
                }}
              />
            </Col>
            <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <DatePicker
                style={{width: "100%"}}
                defaultValue={dateEnd}
                format="DD.MM.YYYY"
                size="normal"
                name="dateEnd"
                placeholder={i18n.t('reportsPage.statsRefusedDeliveries.filter.dateEnd.placeholder')}
                allowClear={false}
                onChange={(date) => {
                  setDateEnd(date);
                }}
              />
            </Col>

            {isOwnerUser && (
              <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
                <ConsignorFilterSelect
                  isOwnerUser={isOwnerUser}
                  consignors={consignorFilter.consignors}
                  selectedConsignor={selectedConsignor}
                  onChange={(value) => {
                    setSelectedConsignor(value);
                  }}
                />
              </Col>
            )}

            <Col lg={colW} md={colW} sm={12} xs={24} style={{textAlign: "right", height: "40px"}}>
              <Button
                type="primary"
                htmlType="button"
                onClick={() => {
                  setLoading(true);
                  setIsNeedUpdateReport(true);
                }}
                style={{
                  backgroundColor: "#1CAA53",
                  border: "none",
                  height: "100%",
                  width: '100%'
                }}
              >
                {i18n.t('main.buttons.submit')}
              </Button>
            </Col>
          </Row>
        </div>}
      </div>
      <div className="reports__table">
        <div className="reports__table-wrapper">
          <Spinner loading={loading}>
            <Col span={24}>
              <Table
                style={{minWidth: "700px"}}
                columns={columns}
                dataSource={reportData}
                locale={{emptyText: i18n.t('main.empty')}}
                rowKey="id"
                size="small"
                pagination={{
                  pageSize: 50,
                }}
              />
            </Col>
          </Spinner>
        </div>
      </div>
    </React.Fragment>
  );
}
